import React from "react";

import {
    getDataFromResponse,
    getDataWithPromise,
    getNumRowsFromResponse,
} from 'root/DataFunctions/BaseDataFns';

import {handleAjaxError} from "root/DataFunctions/ErrorHandlingFunctions";

export const groupStyles = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    color: 'green',
    fontStyle: 'bold',
    fontSize: 'large'
};

export const groupBadgeStyles = {
    backgroundColor: '#EBECF0',
    borderRadius: '2em',
    display: 'inline-block',
    fontWeight: 'normal',
    lineHeight: '1',
    minWidth: 1,
    padding: '0.16666666666667em 0.5em',
    textAlign: 'center',
    color: 'green',
    fontStyle: 'bold',
    fontSize: 'large'
};

export const formatGroupLabel = data => (
    <div style={groupStyles}>
        <span>{data.label}</span>
        <span style={groupBadgeStyles}>{data.options.length}</span>
    </div>
);

export const genericListboxFetch = ({url, keyFieldName, labelFieldName, additionalFields, filterFn, mapFn, postProcessingFn}) =>
{
    return new Promise((resolve, reject) =>
    {
        if (url === null || url === '')
        {
            throw Error('getDataWithPromise cannot call an empty URL');
        }
        else
        {
            getDataWithPromise(url, 'GET', {}).then(response =>
            {
                let rows = getNumRowsFromResponse(response) > 0 ? getDataFromResponse(response) : [];

                // Perform any custom transformations on the data returned from the API
                if ( mapFn !== undefined )
                {
                    rows = rows.map((rec) =>
                    {
                        return mapFn(rec) ;
                    })
                }

                // Perform any custom filtering
                if ( filterFn !== undefined )
                {
                    if ( typeof filterFn !== 'function' )
                    {
                        throw new Error ("Invalid filter Function passed to genericListboxFetch") ;
                    }
                    else
                    {
                        rows = rows.filter((rec) =>
                        {
                            return filterFn(rec) ;
                        })
                    }
                }

                // Map the data into the format the listbox wants.
                // Each listbox will map the value and label elements from the returned listbox data
                const rval = rows.map((entry) =>
                {
                    let arr = {} ;

                    // Add any additional fields to the response
                    if ( additionalFields !== undefined )
                    {
                        let initialValue = {};
                        arr = additionalFields.reduce((obj, item) => {
                            return {
                                ...obj,
                                [item]: entry[item],
                            };
                        }, initialValue);
                    }

                    return { value: +(entry[keyFieldName]), label: entry[labelFieldName], ...arr} ;
                }) ;

                // Perform any post-processing
                if ( postProcessingFn !== undefined )
                {
                    const f =  postProcessingFn (rval) ;
                    resolve (  f );
                }
                else
                {
                resolve ( rval );
                }
            })
            .catch((jqXHR, textStatus, error) =>
            {
                handleAjaxError(jqXHR, textStatus, error) ;

                reject(jqXHR, textStatus, error);
            });
        }
    });
}
